/** Pick which connected Google account + calendar is used for scheduling, or connect another account. */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Plus } from 'lucide-react';
import api from '../../lib/api';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Button } from '../ui/button';

export async function connectGoogle(hint) {
  const q = new URLSearchParams({ return_to: '/calendar', ...(hint ? { login_hint: hint } : {}) });
  const r = await api.request(`/email-accounts/gmail/auth-url?${q}`);
  window.location.href = r.auth_url;
}

export function AccountPicker({ info, onChanged }) {
  const [calendars, setCalendars] = useState([]);
  const sel = info?.selected;
  useEffect(() => {
    if (!sel?.account_id) return;
    api.request(`/calendar/accounts/${sel.account_id}/calendars`).then((d) => setCalendars(d.calendars)).catch(() => setCalendars([]));
  }, [sel?.account_id]);
  const save = async (account_id, calendar_id) => {
    try { await api.request('/calendar/selection', { method: 'PUT', body: JSON.stringify({ account_id, calendar_id }) }); onChanged(); }
    catch (e) { toast.error(e.message); }
  };
  if (!info?.accounts?.length) return null;
  return (
    <div className="space-y-3" data-testid="calendar-account-picker">
      <div>
        <p className="mb-1 text-xs font-medium text-muted-foreground">Google account</p>
        <Select value={sel?.account_id} onValueChange={(v) => save(v, 'primary')}>
          <SelectTrigger className="h-9 text-sm" data-testid="calendar-account-select"><SelectValue /></SelectTrigger>
          <SelectContent>{info.accounts.map((a) => <SelectItem key={a.id} value={a.id} data-testid={`calendar-account-${a.id}`}>{a.email}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div>
        <p className="mb-1 text-xs font-medium text-muted-foreground">Calendar</p>
        <Select value={sel?.calendar_id} onValueChange={(v) => save(sel.account_id, v)}>
          <SelectTrigger className="h-9 text-sm" data-testid="calendar-calendar-select"><SelectValue placeholder="Primary" /></SelectTrigger>
          <SelectContent>
            {!calendars.some((c) => c.primary) && <SelectItem value="primary">Primary</SelectItem>}
            {calendars.map((c) => <SelectItem key={c.id} value={c.primary ? 'primary' : c.id}>{c.primary ? `${c.name} (primary)` : c.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <Button variant="ghost" size="sm" className="w-full justify-start text-primary" onClick={() => connectGoogle().catch((e) => toast.error(e.message))} data-testid="calendar-connect-another">
        <Plus className="mr-1 h-4 w-4" /> Connect another account</Button>
    </div>
  );
}
